// react and mui stuff
import { useNavigate } from "react-router-dom";

import Button from "@mui/joy/Button"
import Typography from "@mui/joy/Typography";

// data and stuff
import { imgSrc } from "../utils/backend";

export default function NoPage() {
  const nav = useNavigate()
  return (
    <div className="flexMidVert" style={{ flexDirection: "column", textAlign: "center", height: "100%" }}>
      <Typography level="h1">Well that's awkward...</Typography>
      <br/>
      <img src={imgSrc("splash/404.jpg")} alt="Icarus in a chair with missing textures and a sign that says 404 in the background" height="50%" style={{ aspectRatio: "16/9" }}/>
      <br/>
      <Typography level="body-lg">This page doesn't exist!</Typography>
      <br/>
      <Button size="lg" onClick={() => nav("/profile")}>Back to safety</Button>
    </div>
  )
}